import React from "react";
import { Button } from "@carbon/react";
import { InProgress, CheckmarkFilled, ErrorFilled } from "@carbon/icons-react";

const formatTimeDifference = (timestamp, t) => {
  const now = Date.now();
  const diffMs = now - Number(timestamp);

  const minutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (minutes < 60)
    return t("main.fuel.fuelRequestsTable.minutesAgo", { count: minutes });
  if (hours < 24)
    return t("main.fuel.fuelRequestsTable.hoursAgo", { count: hours });
  return t("main.fuel.fuelRequestsTable.daysAgo", { count: days });
};

export const fuelRequestsMapper = (data, t, setModalSingleItem) => {
  if (!Array.isArray(data) || data.length === 0) {
    return { mappedHeaders: [], mappedRows: [] };
  }

  const filteredData = data.filter((item) => item.action !== "CANCELED");

  if (filteredData.length === 0) {
    return { mappedHeaders: [], mappedRows: [] };
  }

  const keys = Object.keys(filteredData[0]);

  const mappedHeaders = [
    ...keys
      .filter(
        (key) =>
          key !== "action" &&
          key !== "state" &&
          key !== "resolutionAt" &&
          key !== "actionAt" &&
          key !== "id",
      )
      .map((key) => ({
        header: `main.fuel.fuelRequestsTable.${key}`,
        key: key,
      })),
    {
      header: "main.fuel.fuelRequestsTable.status",
      key: "status",
    },
  ];

  const sortedData = [...filteredData].sort((a, b) => {
    const dateA = new Date(a.resolutionAt ?? a.created).getTime();
    const dateB = new Date(b.resolutionAt ?? b.created).getTime();
    return dateB - dateA;
  });

  const mappedRows = sortedData.map((item) => {
    const row = {};
    Object.keys(item).forEach((key) => {
      if (key === "action") return;
      if (key === "state") return;
      if (key === "created") {
        const date = new Date(item[key]);

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const min = String(date.getMinutes()).padStart(2, "0");

        row[key] = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
      } else {
        row[key] = String(item[key]);
      }
    });

    let status;
    if (item.action === "NEW" && item.state === "NEW") {
      status = (
        // <span className="indicator_cell">
        //   <ConditionWaitPoint /> {t("main.fuel.fuelRequestsTable.notProcessed")}
        // </span>
        <Button
          className="request_action_button"
          size="sm"
          kind="ghost"
          onClick={() => setModalSingleItem({ open: true, item })}
        >
          {t("main.fuel.fuelRequestsTable.process")}
        </Button>
      );
    } else if (item.action !== item.state && item.state === "NEW") {
      const timeAgo = item.actionAt
        ? formatTimeDifference(item.actionAt, t)
        : "";
      status = (
        <span className="indicator_cell">
          <InProgress fill="blue" />{" "}
          {t("main.fuel.fuelRequestsTable.inProgress", { time: timeAgo })}
        </span>
      );
    } else if (
      item.state === "APPROVED" &&
      (item.action === "APPROVED" || item.action === "AUTOAPPROVED")
    ) {
      const approvedText =
        item.action === "AUTOAPPROVED"
          ? t("main.fuel.fuelHistoryTable.autoApproved")
          : t("main.fuel.fuelRequestsTable.approved");

      status = (
        <span className="indicator_cell">
          <CheckmarkFilled fill="green" /> {approvedText}
        </span>
      );
    } else if (item.action !== item.state && item.state === "CANCELED") {
      status = (
        <span className="indicator_cell">
          <ErrorFilled fill="red" /> {t("main.fuel.fuelRequestsTable.declined")}
        </span>
      );
    }

    return {
      ...row,
      status,
      disabled: !(item.action === "NEW" && item.state === "NEW"),
    };
  });

  return { mappedHeaders, mappedRows };
};
